import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import MaskedInput from "react-text-mask";
import { StringUtil } from "@eres/core";
import { JQModal } from "@my-dld/components/Popup/Utils";
import Popup from "@my-dld/components/Popup/Popup";
import { AppConstants } from "../../../configApp";
import { privateSellApi } from "../../../apis/privatesell";
import { showMessage } from "@my-dld/utils/UIUtils";
import { trackEventWithData } from "@my-dld/utils/Analytics";

interface VProps {
	mobile: string;
	email: string;
	otpCode?: string;
	referenceNumber: string;
	onConfirmed: () => void;
	onResend: () => void;
	onCancel: () => void;
}

/*
 */

interface VSate {
	txtOTP: string;
	formErrors: { [ k: string ]: string | undefined };
	error?: string;
	isLoading: boolean;
	maskedMobile: string;
	maskedEmail: string;
	resendStatus: {
		email: boolean,
		mobile: boolean,
	};
}

class VerifyOTP extends Component<VProps, VSate> {
	isVerified = false;

	constructor( props: VProps ) {
		super( props );
		const { mobile, email, referenceNumber, otpCode } = props;
		let maskedMobile = mobile;
		if ( maskedMobile != undefined ) maskedMobile = mobile.replace( /[^\d]/g, "" ).replace( /\d(?=\d{3})/g, "*" );
		let maskedEmail = email;
		if ( maskedEmail ) maskedEmail = maskedEmail.replace( /^(.)(.*)(.@.*)$/,
			( _, a, b, c ) => a + b.replace( /./g, "*" ) + c,
		);
		let o = otpCode;
		if ( o != undefined ) o = o.replace( /\D/g, "" );
		// txtOTP: privateSellApi.setOTP() ? o ? o : "" : "",
		this.state = {
			isLoading: false,
			formErrors: {},
			txtOTP: "",
			maskedMobile: maskedMobile,
			maskedEmail: maskedEmail,
			resendStatus: {
				email: false,
				mobile: false,
			}
		};
	}


	render() {
		const { formErrors, error, isLoading, maskedEmail, maskedMobile } = this.state;
		const isValid = this.isValid();
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};

		return <Popup
			id="verify-pop" autoOpenMount={ true } showIcon={ false } clickOutsideToDismiss={ false }
			onDismiss={ this.onDismiss } modalMainContainer={ "modal fade show" }>
			<div className={ "modal-body modal-body-passcode" }>
				<div className="text-center">
					<img
						className="mt-3 mb-3"
						src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
				</div>
				<div className="text-center">
					<strong>{ Strings.verification }</strong>
				</div>
				<p className={ "mt-2 text-center passCode-msg" }>{ Strings.otp_send_to_mob_email + " " + maskedMobile + "/" + maskedEmail }</p>
				<TextInputField
					{ ...formProps }
					id={ "txtOTP" }
					error={ formErrors.txtOTP }
					label={ Strings.please_enter_verification_code }
					required={ true }
					maxLength={ 12 }
					containerClassName={ "form-group field-style pass-code-control text-center" }
					inputProps={ { type: "password" } }
					customInput={ <MaskedInput
						keepCharPositions={ true }
						guide={ false }
						placeholderChar={ " " }
						mask={ [ /\d/, /\d/, /\d/, /\d/, /\d/, /\d/ ] }
					/> }
					onValueChange={ ( value, extra ) => {
						this.validateOTP( value, "mobileOTP" );
					} }
				>
					<div className="btn-resend">
						<button onClick={ this.resendMobile } className={ "" }>
							{ !this.state.resendStatus.mobile ?
								Strings.resend :
								<div className="relative spinner-border" role="status">
									<span className="sr-only">Loading...</span>
								</div> }
						</button>
					</div>
				</TextInputField>
				<div className="form-group text-center mb-0">
					<button
						className="btn btn_1 btn_style1 otp-btn" disabled={ !( isValid || isLoading ) }
						onClick={ this.onConfirm }>{ !isLoading ? Strings.verify : "" }
						{ isLoading && <div className="relative spinner-border " role="status">
							<span className="sr-only">Loading...</span>
						</div> }

					</button>
				</div>
				{ error && <div className="invalid-feedback invalid-feedback-x">
					{ error }
				</div> }
			</div>
		</Popup>;
	}

	onDismiss = () => {
		if ( !this.isVerified ) {
			this.props.onCancel();
		}
	};

	setResendStat( key: string, val: boolean, cb?: () => void ) {
		this.setState( s => {
			return {
				resendStatus: {
					...s.resendStatus,
					[ key ]: val,
				}
			};
		}, cb );
	}

	resendMobile = () => {
		this.props.onResend();
	};
	validateOTP = ( value: string, key: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( key, Strings.form_required_label );
		} else if ( value.length < 4 ) {
			this.setError( key, Strings.invalid_otp );
		} else {
			this.setError( key, undefined );
		}
	};
	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	isValid = () => {
		let isError = StringUtil.isEmptyStringOrNull( this.state.txtOTP );
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};
	onConfirm = () => {
		this.isVerified = false;
		const { referenceNumber, mobile, email } = this.props;
		this.setState( { isLoading: true } );
		const apiHandler = ( apiResponse: any ) => {
			this.setState( { isLoading: false } );
			trackEventWithData( "PrivateSell", "VerifyOTPSuccess", {
				bookingRef: referenceNumber,
				value: mobile != undefined ? mobile : email,
			} );
			if ( apiResponse && apiResponse.isVerified === true ) {
				//  const {m, e, data} = this.props.navigation.state.params!;
				this.isVerified = true;
				JQModal( "verify-pop" ).hide( () => {
					this.props.onConfirmed();
				} );
			} else {
				trackEventWithData( "PrivateSell", "VerifyOTPSuccess", {
					bookingRef: referenceNumber,
					value: mobile != undefined ? mobile : email,
					error: Strings.invalid_otp,
				} );
				showMessage( Strings.invalid_otp );
			}
		};
		const exHandler = ( ex: any ) => {
			this.setState( { isLoading: false } );
			trackEventWithData( "PrivateSell", "VerifyOTPSuccess", {
				bookingRef: referenceNumber,
				value: mobile != undefined ? mobile : email,
				error: Strings.invalid_otp,
			} );
			showMessage( Strings.invalid_otp );
		};
		privateSellApi.verifyTokenPS( referenceNumber, this.state.txtOTP, mobile ).then( apiHandler ).catch( exHandler );
	};

}

export default VerifyOTP;
